<template>
  <AppModalEdit v-model="visible" @clickExec="apply" exec-button-text="設定">
    <CreativeSelector
      v-model="creatives"
      :resources="resources"
      :creative-type="creativeType"
      @select="previewCreative"
      @reload="reloadCreative"
    />
    <Preview ref="preview" :current-creative="currentCreative" />
  </AppModalEdit>
</template>

<script>
import CreativeSelector from './CampaignModalPageCreativeSelector'
import Preview from './CampaignModalPageCreativePreview'

export default {
  name: 'CampaignModalPageCreativeModeDeliveryGroupModalEdit',
  components: { CreativeSelector, Preview },
  props: {
    value: Boolean,
    creativeSchedule: {
      type: Object,
      required: true,
    },
    resources: {
      type: Array,
      required: true,
    },
    creativeType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentCreative: null,
      creatives: [...this.creativeSchedule.creatives],
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    async apply() {
      this.creativeSchedule.creatives = this.creatives
      this.visible = false
      this.$emit('apply')
    },
    previewCreative(creative) {
      this.currentCreative = creative
    },
    reloadCreative() {
      this.$refs.preview.reload()
    },
  },
}
</script>

<style></style>
